import ProposalListContainer from './ProposalListContainer';
export default ProposalListContainer;
